import { useGetSavedSlidesQuery } from "@api/slides-library";
import { useAccountStore } from "@features/account-management";
import {
  isGlobalLibraryOrg,
  useSlidesLibraryStore,
} from "@modules/slides-library/shared";
import {
  useGetCurrentUserQuery,
  useGetSlidesFoldersQuery,
} from "@/shared/services";
import { isPopularFolder } from "../utils";

export const useGetSavedSlides = () => {
  const { data: me } = useGetCurrentUserQuery();
  const activeFolderId = useSlidesLibraryStore((s) => s.folderId);
  const { data: folders } = useGetSlidesFoldersQuery();
  const orgId = useAccountStore((s) => s.account?._id);

  // The "Most popular" smart-folder view is a curation-org-only concept; for
  // regular orgs a folder that happens to be titled "Most popular" is just a
  // normal folder.
  const isPopular =
    isGlobalLibraryOrg(orgId) && isPopularFolder(folders, activeFolderId);

  const { data, isLoading, isFetching } = useGetSavedSlidesQuery(
    {
      userId: me?.oktaId as string,
      folderId: activeFolderId,
      isPopular,
    },
    {
      skip: !me?.oktaId,
    },
  );

  return { data, isLoading, isFetching, isPopular };
};
